module.exports = __webpack_public_path__ + "img/roll-673.2893b7cf.png";